import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import ImagePreviewForUpload from "src/components/Form/imagePreview";
import { imageUrl } from "src/request/types";
import { updateBankAccountSaga } from "src/store/bankaccounts/saga";
import { BankAccountDto } from "src/store/bankaccounts/type";
import * as Yup from "yup";

const BankAccountEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: BankAccountDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("BankAccount.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          BankName: data.BankName,
          AccountNumber: data.AccountNumber,
          Iban: data.Iban,
          OwnerName: data.OwnerName,
        }}
        onSubmit={(values) => {
          dispatch(
            updateBankAccountSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          OwnerName: Yup.string().required(t("Validation.Required").toString()),
          Iban: Yup.string().required(t("Validation.Required").toString()),
          AccountNumber: Yup.string().required(
            t("Validation.Required").toString()
          ),
          BankName: Yup.string().required(t("Validation.Required").toString()),
        })}
        inputs={[
          {
            field: "OwnerName",
            label: t("BankAccount.OwnerName").toString(),
          },
          {
            field: "BankName",
            label: t("BankAccount.BankName").toString(),
          },
          {
            field: "AccountNumber",
            label: t("BankAccount.AccountNumber").toString(),
          },
          {
            field: "Iban",
            label: t("BankAccount.Iban").toString(),
          },
        ]}
      />
    </React.Fragment>
  );
};
export default BankAccountEditForm;
